/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharereviewcolumndecision3Inputs */

const en_sharereviewcolumndecision3 = /** @type {(inputs: Sharereviewcolumndecision3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decision`)
};

const de_sharereviewcolumndecision3 = /** @type {(inputs: Sharereviewcolumndecision3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entscheidung`)
};

/**
* | output |
* | --- |
* | "Decision" |
*
* @param {Sharereviewcolumndecision3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharereviewcolumndecision3 = /** @type {((inputs?: Sharereviewcolumndecision3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharereviewcolumndecision3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharereviewcolumndecision3(inputs)
	return de_sharereviewcolumndecision3(inputs)
});
export { sharereviewcolumndecision3 as "shareReviewColumnDecision" }